import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {CombineImage_Map, IMAGE_MAP, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Toast} from 'gotu-ui'
import {FragmentModule, MainButton, RewardInfo, SubActivityModule} from '@/service/activity'
import {useUaParam} from '@/pages/_app'
import {openWindow} from '@/plugins/bridge'
import {useCombine} from '@/pages/activity/tenyears/combine'
const styles = require('./style.module.less')
interface ModuleProps {
  fragmentModule: FragmentModule,
  leave: boolean,
  scrollModule: (type: 'main' | 'child') => void,
  mainButton: MainButton
  combineRef: any
}
interface newRewardInfo extends RewardInfo {
  hasPick: boolean
}

const Fragment = (props: ModuleProps) => {
    const {
        fragmentModule,
        leave,
        scrollModule,
        mainButton,
        combineRef,
    } = props
    const {isApp} = useUaParam()
    const {
        activeFraId,
        setActiveFraId,
        getData,
        setData,
        data,
    } = useCombine()
    const {isShow, fragmentList} = fragmentModule
    const timer = useRef<any>(null)
    const timer2 = useRef<any>(null)
    const timer3 = useRef<any>(null)
    const [activeTipIndex, setActiveTipIndex] = useState(-1)
    const [guideIndex, setGuideIndex] = useState(-1)
    const [fragmentFinally, setFragmentFinally] = useState<newRewardInfo[]>([])
    useEffect(() => {
        if (fragmentFinally.length === 0 || mainButton.status === 4) {
            setFragmentFinally(fragmentList.map((item) => { return {...item, hasPick: item.count > 0 ? true : false} }))
        }
    }, [fragmentList, mainButton])
    useEffect(() => {
        if (activeFraId) {
            clearTimeout(timer.current)
            timer.current = null
            // const index = fragmentFinally.findIndex((item) => item.rewardId === activeFraId && !item.hasPick)
            // setFragmentFinally((pre) => {
            //     return pre.map((item) => {
            //         if (item.rewardId === id) {
            //             const data = {...item, count: item.count + 1}
            //             return data
            //         }
            //         return {...item}
            //     })
            // })
            // if (index === -1) {
            //     return
            // }
            // 当前碎片发生变化，并且是新碎片滚动到顶部 , 不再手动控制碎片数量，由后端控制
            combineRef.current.scrollTop = 0
            const id = activeFraId
            timer.current = setTimeout(() => {
                // setActiveTipIndex(index)
                getData()
                clearTimeout(timer.current)
                timer.current = null
            }, 200)

            setActiveFraId(0)
        }
    }, [activeFraId, fragmentFinally])
    const pickCake = (index: number) => {
        // 测试动画时使用
        // if (data) {
        //     setData({
        //         ...data,
        //         fragmentModule: {
        //             ...data.fragmentModule,
        //             fragmentList: [
        //                 ...data.fragmentModule.fragmentList.map((item) => {
        //                     return {...item, count: item.count + 1}
        //                 })],
        //         },
        //     })
        //     setTimeout(() => {
        //         setData({
        //             ...data,
        //             fragmentModule: {
        //                 ...data.fragmentModule,
        //                 fragmentList: [
        //                     ...data.fragmentModule.fragmentList.map((item) => {
        //                         return {...item, count: item.count + 1}
        //                     })],
        //             },
        //             mainButton: {...data.mainButton, status: 4},
        //         })
        //     },2000)
        //     return
        // }
        // 不在通过用户触发蛋糕下落动画，自动触发
        // if (timer.current || activeTipIndex !== -1) {
        //     getData()
        //     setActiveTipIndex(-1)
        // } else {
        clearTimeout(timer.current)
        setGuideIndex(index)
        clearTimeout(timer3.current)
        timer3.current = setTimeout(() => {
            setGuideIndex(-1)
            clearTimeout(timer3.current)
        }, 3000)
        // }
    }
    const goMain = () => {
        scrollModule('child')
    }
    // 导航栏引导出现时，不在出现需要拼接的碎片
    useEffect(() => {
        if (guideIndex !== -1) {
            clearTimeout(timer2.current)
            timer2.current = setTimeout(() => {
                setActiveTipIndex(-1)
            }, 3000)
        }
        return () => {
            clearTimeout(timer2.current)
        }
    }, [guideIndex])
    if (isShow) {
        return (
            <div className={classNames(leave && styles['left-leave'], styles.fragments)}>
                {
                    fragmentList.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className='por'
                            >
                                <div

                                    className={styles.item}
                                    onClick={() => pickCake(index)}
                                >
                                    <I
                                        className={styles.img}
                                        src={item.rewardImgUrl}
                                        width={36}
                                        height={36}
                                    ></I>
                                    <div className={styles.corn}><span className={styles.txt}>{ item.count}</span></div>
                                </div>
                                {/* {
                                    activeTipIndex === index && (
                                        <div className={styles.tips}>
                                            点击碎片拼蛋糕
                                            <div className={styles['tip-bg']}>
                                                <svg
                                                    className={styles.icon}
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    width='22'
                                                    height='34'
                                                    viewBox='0 0 22 34'
                                                    fill='none'
                                                >
                                                    <g clipPath='url(#clip0_982_1175)'>
                                                        <path
                                                            fillRule='evenodd'
                                                            clipRule='evenodd'
                                                            d='M3.72993 21.9434L0.612465 18.9404C-0.204155 18.1537 -0.204155 16.8463 0.612465 16.0596L3.38416 13.3896C5.03957 5.73507 11.85 0 20 0H94C103.389 0 111 7.61116 111 17C111 26.3888 103.389 34 94 34H20C12.3305 34 5.84728 28.9212 3.72993 21.9434Z'
                                                            fill='black'
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id='clip0_982_1175'>
                                                            <rect
                                                                width='22'
                                                                height='34'
                                                                fill='white'
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                        </div>
                                    )
                                } */}
                                {
                                    guideIndex === index && (
                                        <div className={styles.tips}>
                                            <div className={styles['tip-bg']}>
                                                <svg
                                                    className={styles.icon}
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    width='22'
                                                    height='34'
                                                    viewBox='0 0 22 34'
                                                    fill='none'
                                                >
                                                    <g clipPath='url(#clip0_982_1175)'>
                                                        <path
                                                            fillRule='evenodd'
                                                            clipRule='evenodd'
                                                            d='M3.72993 21.9434L0.612465 18.9404C-0.204155 18.1537 -0.204155 16.8463 0.612465 16.0596L3.38416 13.3896C5.03957 5.73507 11.85 0 20 0H94C103.389 0 111 7.61116 111 17C111 26.3888 103.389 34 94 34H20C12.3305 34 5.84728 28.9212 3.72993 21.9434Z'
                                                            fill='black'
                                                        />
                                                    </g>
                                                    <defs>
                                                        <clipPath id='clip0_982_1175'>
                                                            <rect
                                                                width='22'
                                                                height='34'
                                                                fill='white'
                                                            />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            完成任务得蛋糕切块哦～
                                            <div
                                                className={styles['tip-b']}
                                                onClick={goMain}
                                            >
                                                去完成
                                            </div>
                                            <div className='poa l0'>
                                                <svg
                                                    viewBox='0 0 50 50'
                                                >
                                                    <polygon
                                                        points='25,0 50,50 0,50'
                                                        fill='black'
                                                    />
                                                </svg>
                                            </div>

                                        </div>
                                    )
                                }
                            </div>

                        )
                    })
                }
            </div>
        )
    }
    return null
}

export default Fragment
